/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EventRequest,
  EventResponse,
  HTTPValidationError,
} from '../models/index';
import {
    EventRequestFromJSON,
    EventRequestToJSON,
    EventResponseFromJSON,
    EventResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface CreateEventApiV1EventsPostRequest {
    eventRequest: EventRequest;
}

/**
 * 
 */
export class EventsApi extends runtime.BaseAPI {

    /**
     * Create a new event in the system.  This endpoint is generic and can handle various event types including: - user_feedback: User feedback with ratings and comments - UserInteraction: User interface interactions - SystemLog: System-level logging events - Error: Error tracking events  Args:     request: Event request containing type, content, and timestamp     current_user: Authenticated user information     events: Event publisher dependency     logger: Logger dependency     settings: Application settings dependency  Returns:     EventResponse with only the event ID and success message  Raises:     HTTPException: If event creation fails
     * Create Event
     */
    async createEventApiV1EventsPostRaw(requestParameters: CreateEventApiV1EventsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventResponse>> {
        if (requestParameters['eventRequest'] == null) {
            throw new runtime.RequiredError(
                'eventRequest',
                'Required parameter "eventRequest" was null or undefined when calling createEventApiV1EventsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/events/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventRequestToJSON(requestParameters['eventRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventResponseFromJSON(jsonValue));
    }

    /**
     * Create a new event in the system.  This endpoint is generic and can handle various event types including: - user_feedback: User feedback with ratings and comments - UserInteraction: User interface interactions - SystemLog: System-level logging events - Error: Error tracking events  Args:     request: Event request containing type, content, and timestamp     current_user: Authenticated user information     events: Event publisher dependency     logger: Logger dependency     settings: Application settings dependency  Returns:     EventResponse with only the event ID and success message  Raises:     HTTPException: If event creation fails
     * Create Event
     */
    async createEventApiV1EventsPost(requestParameters: CreateEventApiV1EventsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventResponse> {
        const response = await this.createEventApiV1EventsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
